import * as React from 'react';
import { BadgeSVGProps } from '../../BadgeImage/BadgeImage.types';

export const REnd = ({
	finish,
	shineAsset,
}: BadgeSVGProps) => (
	<svg 
		version="1.1" 
		id="Layer_1" 
		xmlns="http://www.w3.org/2000/svg" 
		xmlnsXlink="http://www.w3.org/1999/xlink" 
		x="0px" 
		y="0px"
		viewBox="0 0 400 91" 
		enableBackground="new 0 0 400 91" 
		xmlSpace="preserve"
	>
		<g>
			<linearGradient id="SVGID_3_" className="background-colour" gradientUnits="userSpaceOnUse" x1="200" y1="84.7208" x2="200" y2="5.058">
				<stop  offset="0" style={{ stopColor: "#072653" }} />
				<stop  offset="0.5379" style={{ stopColor: "#072551" }} />
				<stop  offset="0.7317" style={{ stopColor: "#07224A" }} />
				<stop  offset="0.8694" style={{ stopColor: "#061D3F" }} />
				<stop  offset="0.9803" style={{ stopColor: "#07205162E53" }} />
				<stop  offset="1" style={{ stopColor: "#05142A" }} />
			</linearGradient>
				<path className="background-colour" fill="url(#SVGID_3_)" d="M394.3,44.9c0,21.9-18.2,39.8-40.5,39.8H46.2c-22.3,0-40.5-17.9-40.5-39.8S23.9,5.1,46.2,5.1h307.7
					C376.1,5.1,394.3,23,394.3,44.9z"/>
				<linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="200" y1="91.0432" x2="200" y2="-6.907612e-09">
					<stop  offset="0" style={{stopColor: finish.dark}} />
					<stop  offset="3.285236e-02" style={{ stopColor: finish.dark }} />
					<stop  offset="7.363299e-02" style={{ stopColor: finish.dark }} />
					<stop  offset="0.1218" style={{ stopColor: finish.dark }} />
					<stop  offset="0.1814" style={{ stopColor: finish.light }} />
					<stop  offset="0.2649" style={{ stopColor: finish.light }} />
					<stop  offset="0.4969" style={{ stopColor: finish.light }} />
					<stop  offset="0.7315" style={{ stopColor: finish.light }} />
					<stop  offset="0.816" style={{ stopColor: finish.light }} />
					<stop  offset="0.8762" style={{ stopColor: finish.dark }} />
					<stop  offset="0.9249" style={{ stopColor: finish.dark }} />
					<stop  offset="0.9661" style={{ stopColor: finish.dark }} />
					<stop  offset="0.9993" style={{ stopColor: finish.dark }} />
				</linearGradient>
				<path fill="url(#SVGID_4_)" d="M394.3,45.5h-5.7c0,9.4-3.9,17.9-10.2,24.1c-6.3,6.2-15,10.1-24.6,10.1H46.2
					c-9.6,0-18.3-3.9-24.6-10.1c-6.3-6.2-10.2-14.7-10.2-24.1c0-9.4,3.9-17.9,10.2-24.1c6.3-6.2,15-10.1,24.6-10.1h307.7
					c9.6,0,18.3,3.9,24.6,10.1c6.3,6.2,10.2,14.7,10.2,24.1H394.3h5.7c0-12.5-5.2-24-13.6-32.2C378.1,5.1,366.5,0,353.8,0H46.2
					C33.5,0,21.9,5.1,13.6,13.3C5.2,21.6,0,33,0,45.5c0,12.5,5.2,24,13.6,32.2C21.9,85.9,33.5,91,46.2,91h307.7
					c12.7,0,24.2-5.1,32.6-13.3c8.4-8.2,13.6-19.6,13.6-32.2H394.3z"/>
				<image overflow="visible" width="492" height="122" xlinkHref={shineAsset}  transform="matrix(1 0 0 1 -44 -15)">
				</image>
		</g>
	</svg>
);
